export default class ParentReceiver {
  constructor() {
    this._subscribers = [];
    window.addEventListener('message', (event) => {
      this._subscribers.forEach((cb) => cb(event));
    });
  }

  subscribe(callback) {
    this._subscribers.push(callback);
  }
}
